import { useEffect, useMemo } from 'react';

import { SecondaryTabs } from 'modules/common/components/SecondaryTabs';
import { sortGroupTabs } from 'modules/common/utils/sortGroupTabs';
import { useTabs } from 'modules/common/hooks/useTabs';

import { MIN_GROUP_TABS } from './constants';
import { getGroupTabs } from './utils/getGroupTabs';
import { useChainSelectors } from '../ChainSelectorsProvider';
import { useGroupTabsStyles } from './useGroupTabsStyles';

export interface GroupTabsProps {
  className?: string;
  classNameTab?: string;
  classNameTabsInner?: string;
  classNameTabsWrapper?: string;
  visible?: boolean;
}

export const GroupTabs = ({
  className,
  classNameTab,
  classNameTabsInner,
  classNameTabsWrapper,
  visible,
}: GroupTabsProps | void = {}) => {
  const { group, groups, setGroupID } = useChainSelectors();

  const tabs = useMemo(
    () => sortGroupTabs(getGroupTabs(groups, id => setGroupID(id))),
    [groups, setGroupID],
  );

  const [groupTabs, groupTab] = useTabs({
    initialTabID: group.id,
    tabs,
  });

  const { classes, cx } = useGroupTabsStyles();

  // this effect fixes case when the user switched a project with a selected group(for example, flare testnet) and see the wrong group
  useEffect(() => {
    if (groupTab && group.id !== groupTab.id) {
      setGroupID(groupTab.id);
    }
    // this effect should be triggered when user changes selected project in endpoints modal
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group]);

  if (groupTabs.length < MIN_GROUP_TABS) {
    return null;
  }

  return (
    <SecondaryTabs
      className={cx(classes.root, className)}
      classNameTab={classNameTab}
      classNameTabsInner={classNameTabsInner}
      classNameTabsWrapper={classNameTabsWrapper}
      selectedTab={groupTab}
      tabs={groupTabs}
      visible={visible}
    />
  );
};
